import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  const preview = faqs.slice(0, 5);

  return (
    <section className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="常见问题"
            title="投稿前，你可能想知道"
            desc="这里整理了投稿人问得最多的几个问题。完整说明请查看常见问题页。"
          />
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/15 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-question-line text-base" aria-hidden="true"></i>
            查看全部问题
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={preview} />
        </div>
      </div>
    </section>
  );
}